import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "../store/actions/edit-document.actions";
import { actions as newDocumentActions } from "../store/actions/new-document.actions";
import { actions as contractorActions } from "../../../actions/contractor.actions";
import { Form } from "antd";
import EditDoneDateModal from "./EditDoneDateModal";
import EditResponsibleWorkerModal from "./EditResponsibleWorkerModal";
import EditAppointedWorkerModal from "./EditAppointedWorkerModal";
import EditNumberDateModal from "./EditNumberDateModal";
import EditTopicModal from "./EditTopicModal";
import EditContractorModal from "./EditContractorModal";
import documentEditMode from "../constants/documentEditMode";
import EditAddressModal from "./EditAddressModal";
import EditStatusModal from './EditStatusModal/EditStatusModal';
import { EditVisibilityModal } from './EditVisibilityModal';
import { EditReminderModal } from "./EditReminderModal";
import EditTopicIdModal from "./EditTopicIdModal";
import EditResponceTimeModal from "./EditResponceTimeModal";

const EditDocumentForm = (props) => {
	const { visible, onCancel, form, prepareDataAndResetFields } =
		props;
	const fprops = props.fprops.documentData;
	fprops.docNumber = fprops.docNumber && fprops.docNumber.split("/")[0];

	const { getFieldDecorator, validateFields } = form;

	const docType = fprops.type && fprops.type.id;
	const editMode = fprops.editMode;

	getFieldDecorator("typeId", { initialValue: docType });
	getFieldDecorator("InNumber", { initialValue: fprops.inNumber });
	getFieldDecorator("ordTypeId", {
		initialValue: fprops.organizationalType && fprops.organizationalType.id,
	});
	getFieldDecorator("Description", { initialValue: fprops.description });

	getFieldDecorator("keys", { initialValue: [0] });

	const commonProps = {
		getFieldDecorator,
		validateFields,
		prepareDataAndResetFields,
		onCancel,
		visible,
		form,
	};

	switch (editMode) {
		case documentEditMode.NUMBER_DATE: {
			return (
				<EditNumberDateModal
					{...commonProps}
					fprops={fprops}
				/>
			);
		}
		case documentEditMode.DONE_DATE: {
			return <EditDoneDateModal doneDate={fprops.doneDate} {...commonProps} />;
		}
		case documentEditMode.TOPIC: {
			return (
				<EditTopicModal
					docType={docType}
					{...commonProps}
					fprops={fprops}
				/>
			);
		}
		case documentEditMode.TOPIC_ID: {
			return (
				<EditTopicIdModal
					docType={docType}
					{...commonProps}
					topicId={fprops.topicId}
				/>
			);
		}
		case documentEditMode.EXECUTER: {
			return (
				<EditAppointedWorkerModal
          workersList={
            fprops.serviceCompanyId
              ? props.fprops.listExecuter.filter(
                  (executer) =>
                    executer.serviceCompanyId === fprops.serviceCompanyId
                )
              : props.fprops.listExecuter
          }
					editAppointedWorker={fprops.editAppointedWorker}
					{...commonProps}
				/>
			);
		}
		case documentEditMode.RESPONSIBLE_WORKER: {
			return (
				<EditResponsibleWorkerModal
					responsibleWorker={fprops.responsibleWorker}
          workersList={
            fprops.serviceCompanyId
              ? props.fprops.responsibleWorkers.filter(
                  (respWorker) =>
                    respWorker.companyId === fprops.serviceCompanyId
                )
              : props.fprops.responsibleWorkers
          }
					{...commonProps}
				/>
			);
		}
		case documentEditMode.CONTRACTOR: {
			return (
				<EditContractorModal
					contractorsList={props.fprops.documentContractors}
					{...commonProps}
					fprops={fprops}
					form={form}
				/>
			);
		}
		case documentEditMode.ADDRESS: {
			return (
				<EditAddressModal
					resetFields={form.resetFields}
					{...commonProps}
					editAddressConnectId={fprops?.editAddressConnectId}
				/>
			);
		}
		case documentEditMode.STATUS: {
			return (
				<EditStatusModal
					status={fprops.status}
					statusesList={props.fprops.filterStatus}
					{...commonProps}
				/>
			);
		}
    case documentEditMode.VISIBILITY: {
      return (
        <EditVisibilityModal
          fprops={fprops}
          listDocumentVisibility={props.fprops.listDocumentVisibility}
          {...commonProps}
        />
      );
    }
    case documentEditMode.REMINDER: {
      return (
        <EditReminderModal
          fprops={fprops}
          {...commonProps}
          form={form}
        />
      );
    }
		case documentEditMode.RESPONCE_TIME: {
      return <EditResponceTimeModal deadlineDate={fprops.deadlineDate} {...commonProps} />;
      
    }
		default:
			return <div />;
	}
};

const EditDocumentContainer = Form.create()(
	class EditDocumentContainer extends Component {
		componentDidMount() {
			this.props.dispatch(newDocumentActions.fetchExecuterList());
			this.props.dispatch(contractorActions.fetchDocumentContractorList());
			this.props.dispatch(newDocumentActions.fetchAddrStreetList());
		}

		handleCancel = () => {
			const form = this.props.form;
			form.resetFields();
			this.props.dispatch(actions.closeModal());
		};

		prepareDataAndResetFields = (values) => {
			const form = this.props.form;
			const v = { ...this.props.documentData, ...values };
			form.resetFields();
			return v;
		};

    /*
		handleCreate = () => {
			const form = this.props.form;


			form.validateFields((err, values) => {
				if (err) return;
				const v = this.prepareDataAndResetFields(values);
				console.log('form values', v)
				this.props.dispatch(actions.updateDocument(v));

				this.props.dispatch(actions.closeModal());
			});
		};
    */

		render() {
			return (
				<EditDocumentForm
					visible={this.props.modalVisible}
					dispatch={this.props.dispatch}
					onCancel={this.handleCancel}
					prepareDataAndResetFields={this.prepareDataAndResetFields}
					form={this.props.form}
					fprops={this.props}
				/>
			);
		}
	}
);

function mapStateToProps(state) {
	const { editDocumentStore } = state;
	const {
		listExecuter,
		listAddrStreet,
		listAddrBuilding,
		listAddrFlat,
		valueAddrStreet,
		valueAddrBuilding,
		valueAddrFlat,
		responsibleWorkers,
    listDocumentVisibility,
	} = state.newDocumentStore;
	const { documentContractors } = state.contractorStore;
	const { filterStatus } = state.documentsStore;
	return {
		...editDocumentStore,
		documentContractors,
		listExecuter,
		listAddrStreet,
		listAddrBuilding,
		listAddrFlat,
		valueAddrStreet,
		valueAddrBuilding,
		valueAddrFlat,
		filterStatus,
		responsibleWorkers,
    listDocumentVisibility,
	};
}

export default connect(mapStateToProps)(EditDocumentContainer);
